import { render } from "./Switch.vue?vue&type=template&id=0adf587f&scoped=true&ts=true"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"

import "./Switch.vue?vue&type=style&index=0&id=0adf587f&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adf587f"]])

export default __exports__